import type { AxiosError } from "axios"
import { X } from "lucide-react"
import { toast } from "react-hot-toast"

export function showValidationErrorToastDev(error: AxiosError) {
  const errorUrl = error.config?.url

  toast.error(
    <div>
      <div className="flex items-center gap-2 text-md">
        <div className="text-red-500">{error.status}</div>
        <div className="font-semibold">{errorUrl}</div>
      </div>
      <pre className="mt-2 rounded-lg bg-red-50 p-4 font-semibold">{JSON.stringify(error.response?.data || {}, null, 2)}</pre>
    </div>,
    {
      className: "!min-w-fit !max-w-none",
      style: {
        width: "auto",
        whiteSpace: "nowrap",
        maxWidth: "none"
      }
    }
  )
}

// type ValidationErrorResponse = Record<string, Array<Record<string, string[]>> | Record<string, string>>
type ValidationErrorResponse = {
  errors: string[]
}

export function showValidationErrorToast(error: AxiosError) {
  const errorData = error.response?.data as ValidationErrorResponse

  const errorMessages: string[] = []

  // console.log({ errorData })

  // if (errorData) {
  //   Object.values(errorData).forEach(items => {
  //     if (Array.isArray(items)) {
  //       items.forEach(item => {
  //           Object.values(item).forEach(messages => {
  //             if (Array.isArray(messages)) {
  //               messages.forEach(msg => errorMessages.push(msg))
  //             }
  //           })
  //         }
  //       )
  //     } else {
  //       Object.values(items).forEach(messages => {
  //         errorMessages.push(messages)
  //       })
  //     }
  //   })
  // }

  // if (errorMessages.length === 0) {
  //   errorMessages.push("Произошла неизвестная ошибка.")
  // }
  if (errorData.errors.length === 0) {
    errorMessages.push("Произошла неизвестная ошибка.")
  } else {
    errorMessages.push(...errorData.errors)
  }

  // Extended toast duration (e.g., 10 seconds instead of default 4–5 seconds)
  const toastDuration = 10000 // in ms

  toast.error(
    t => (
      <div className="relative flex flex-col gap-1">
        <button title="close" type="button" onClick={() => toast.dismiss(t.id)} className="absolute top-1 right-1 text-gray-400 hover:text-gray-600">
          <X size={16} />
        </button>

        {errorMessages.map((msg, idx) => (
          <div key={idx}>{msg}</div>
        ))}
      </div>
    ),
    {
      duration: toastDuration,
      className: "!min-w-fit !max-w-none",
      style: {
        width: "auto",
        whiteSpace: "nowrap",
        maxWidth: "none"
      }
    }
  )
}
